<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="80" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label-width="0">
          <ElInput v-model.trim="keyword" :placeholder="placeholder" style="width: 220px" @keyup.enter.native="search">
            <i slot="append" @click="search" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>
        <ElFormItem label="创建人">
          <auto-complete :data="agentData" width="110" v-model="agentId" placeholder="全部" @on-select="handleAgent"></auto-complete>
        </ElFormItem>
        <ElFormItem class="bg-transparent">
          <Button type="primary" @click="open">新建管控规则</Button>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import { isArray, debounce, trim } from '@/common/js/utils'
import { getSysMember } from '@/api/common.model'
import AutoComplete from '@/components/autocomplete/autocomplete'
export default {
  name: 'monitorFilter',
  components: { AutoComplete },
  props: {
    placeholder: {
      type: String
    }
  },
  methods: {
    sendEvent() {
      const keyword = trim(this.keyword)
      const params = {
        mediaId: this.media === -1 ? undefined : this.media,
        type: this.type === -1 ? undefined : this.type,
        opId: this.agentId === '' ? undefined : this.agentId,
        keyword: keyword === '' ? undefined : keyword
      }
      this.$emit('on-change', params)
    },
    search() {
      const keyword = trim(this.keyword)
      const params = {
        mediaId: this.media === -1 ? undefined : this.media,
        type: this.type === -1 ? undefined : this.type,
        opId: this.agentId === '' ? undefined : this.agentId,
        keyword: keyword === '' ? undefined : keyword
      }
      this.$emit('on-search', params)
    },
    proloadData() {
      getSysMember()
        .then((data) => {
          if (isArray(data)) {
            this.agentData = data.map((ret) => {
              // ret.id = ret.opId
              return ret
            })
          }
          // 初始化
          this.sendEvent()
        })
        .catch((error) => {
          this.$Message.error({
            duration: 5,
            content: error
          })
        })
    },
    handleAgent(meta) {
      this.agentId = meta.id
    },
    open() {
      this.$router.push({ name: 'adcountwarnadd' })
    }
  },
  watch: {
    media(nVal) {
      this.sendEvent()
    },
    type(nVal) {
      this.sendEvent()
    },
    agentId(nVal) {
      debounce(() => {
        this.sendEvent()
      }, 500)()
    }
  },
  data() {
    return {
      keyword: '',
      media: -1,
      type: -1,
      agentId: '',
      agentData: []
    }
  },
  created() {
    this.proloadData()
  }
}
</script>
